import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router'

interface Props {
  isEdit: boolean
  onSubmit: () => Promise<void>
}
export const RoleFormHeader = observer(({ isEdit, onSubmit }: Props) => {
  const navigate = useNavigate()
  const { t } = useTranslate()

  const action = isEdit ? t('editRole', 'Edit role') : t('addNewRole', 'Add new role')
  const breadCrumbs = [
    { label: t(PATHS.config.roles.title), route: PATHS.config.roles.url },
    { label: action },
  ]

  return (
    <Header
      title={action}
      breadcrumbs={breadCrumbs}
      position='relative'
      rightRenderOption={
        <>
          <Button
            variant='text'
            color='inherit'
            data-cy='cancel-role-btn'
            onClick={() => navigate(PATHS.config.roles.url)}
          >
            {t('cancel', 'Cancel')}
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => onSubmit()}
            data-cy='role-save-btn'
          >
            {t('submit', 'Submit')}
          </Button>
        </>
      }
    />
  )
})
